// Google Analytics 4 Event Tracking Utility

export const trackEvent = (eventName, params = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, params);
  }
};

// Custom Events
export const trackSignupComplete = (method = 'email') => {
  trackEvent('signup_complete', { method });
};

export const trackUpgradeClicked = (plan, interval) => {
  trackEvent('upgrade_clicked', { plan, interval });
};

export const trackItemAddedToInventory = (itemName, value) => {
  trackEvent('item_added_to_inventory', { item_name: itemName, value });
};

export const trackShareCreated = (itemType) => {
  trackEvent('share_created', { item_type: itemType });
};
